import { ScopeSection } from '@app/features/scope-overview/model/scope-section'
import { SectionChanges } from '@app/shared/components/scope-elements/models/entities-with-changes/section-with-changes.interface'

export function getSectionChanges(
  section: ScopeSection,
  previewSection: ScopeSection,
  currency: string
): SectionChanges {
  if (!previewSection) previewSection = section

  return {
    markup: {
      old: +section?.markup,
      new: +previewSection?.totalMarkup,
    },
    totalProfit: {
      old: section?.getTotalProfit(currency)?.amount,
      new: previewSection?.getTotalProfit(currency)?.amount,
    },
    rateCardTotalHours: {
      old: section?.rateCardTotalHours,
      new: previewSection?.rateCardTotalHours,
    },
    totalSellingPrice: {
      old: section?.getTotalSellingPrice()?.amount,
      new: previewSection?.getTotalSellingPrice()?.amount,
    },
  }
}
